import raAdminMessages from 'ra-language-italian'

export default raAdminMessages
